import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/global.less';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './services/localization';
import { Spinner } from '@techsmith/tsc-cloud-style-guide';
const root = ReactDOM.createRoot(document.getElementById('root'));
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
root.render(_jsx(React.Suspense, Object.assign({ fallback: _jsx(Spinner, {}) }, { children: _jsx(BrowserRouter, Object.assign({ basename: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '' }, { children: _jsx(App, {}) })) })));
